import styled from '@emotion/styled';
import { Text as CommonText, Flex } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const FlexWrapper = styled(Flex)`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.previewLayer};
  width: 100vw;
  height: 100vh;

  background: rgb(79 88 96 / 50%);
`;

export const Text = styled(CommonText)`
  flex: 1;
`;
